/** Split a subsection body into titled cards (Figma right pane). */
export function parseItemCards(item) {
  const body = String(item?.body || "").trim();
  if (!body) return [];

  const labeledLine = (line) => {
    const m = String(line).match(/^(.{1,80}?)(?:\s*[:—–]\s+|\s+-\s+)(.+)$/);
    if (!m) return null;
    const title = m[1].replace(/^\d+(\.\d+)*\s+/, "").replace(/\*+/g, "").trim();
    if (!title || title.length > 70) return null;
    return { title, text: m[2].trim() };
  };

  const blocks = body.split(/\n\s*\n/).map((b) => b.trim()).filter(Boolean);
  if (blocks.length >= 2) {
    return blocks.map((block) => {
      const lines = block.split("\n").map((l) => l.trim()).filter(Boolean);
      const fromFirst = labeledLine(lines[0]);
      if (fromFirst) {
        return {
          title: fromFirst.title,
          text: [fromFirst.text, ...lines.slice(1)].filter(Boolean).join("\n"),
        };
      }
      if (lines.length > 1 && lines[0].length <= 70 && !/[.!?]$/.test(lines[0])) {
        return { title: lines[0], text: lines.slice(1).join("\n") };
      }
      return { title: null, text: block };
    });
  }

  const lines = body.split("\n").map((l) => l.replace(/^[-•*]\s+/, "").trim()).filter(Boolean);
  const labeled = lines.map(labeledLine).filter(Boolean);
  if (labeled.length >= 2 && labeled.length >= Math.ceil(lines.length * 0.6)) {
    return labeled;
  }

  return [{ title: null, text: body }];
}

/** Custom flyout cards: one "Subsection Name: description" body (including multiline). */
export function parseCustomItemCards(item) {
  const body = String(item?.body || "").trim();
  if (!body) return [];

  const newline = body.indexOf("\n");
  const firstLine = (newline === -1 ? body : body.slice(0, newline)).trim();
  const rest = newline === -1 ? "" : body.slice(newline + 1).trim();
  const labeled = firstLine.match(/^(.{1,80}?)(?:\s*[:—–]\s+|\s+-\s+)(.+)$/);
  if (labeled) {
    const title = labeled[1].replace(/^\d+(\.\d+)*\s+/, "").replace(/\*+/g, "").trim();
    if (title && title.length <= 70) {
      return [{ title, text: [labeled[2].trim(), rest].filter(Boolean).join("\n") }];
    }
  }

  return parseItemCards(item);
}

/** Rebuild item body from parsed cards after an edit. */
export function rebuildItemBody(cards) {
  if (!cards?.length) return "";
  if (cards.length === 1 && !cards[0].title) return String(cards[0].text || "").trim();

  return cards
    .map((c) => {
      const text = String(c.text || "").trim();
      if (c.title) return `${c.title}: ${text}`.trim();
      return text;
    })
    .filter(Boolean)
    .join("\n\n");
}

export function updateItemCardBody(item, cardIndex, newText) {
  const cards = parseItemCards(item);
  if (!cards.length) {
    return String(newText || "").trim();
  }
  const idx = cardIndex != null && cardIndex >= 0 ? cardIndex : 0;
  const next = cards.map((c, i) => (i === idx ? { ...c, text: newText } : c));
  return rebuildItemBody(next);
}
